class UrlsService {
    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }


    public sites(): string {
        return "/sites"
    }

    public sellers(): string {
        return "/sellers"
    }

    public users(): string {
        return "/users"
    }

    public editUser(userId:string = ":id"): string {
        return `${this.users()}/${userId}`
    }

    public addUser(): string {
        return `${this.users()}/add`
    }

    public editDemand(demandId:string = ":id"): string {
        return `${this.demands()}/${demandId}`
    }
    public addDemand(): string {
        return `${this.demands()}/add`
    }
    public demands(): string {
        return "/demands"
    }
    public demandWLGenerator(): string {
        return `/demandWLGenerator`
    }
    public appsData(): string {
        return `/appsData`
    }
    public integrations(): string{
        return `/integrations`
    }
    public newIntegration(): string {
        return `${this.integrations()}/add`
    }
    public editIntegration(integrationId:string = ":id"): string {
        return `${this.integrations()}/${integrationId}`
    }
    public appAds(): string {
        return "/app-ads"
    }
    public appAdsLines(): string {
        return "/app-ads-lines"
    }
    public appAdsLinesAll(): string {
        return `${this.appAdsLines()}/all`
    }
    public addTrackedPublisher(): string {
        return `${this.appAdsLines()}/add`
    }
    /**
     * Publishers are addressed by id.
     *
     * Domain read better - /app-ads-lines/adte.com beats a hex string - but it made the address
     * depend on a field people type into. One publisher was created with a full URL in it and
     * its page became /app-ads-lines/https%3A%2F%2Fwww.example.com%2F, which neither opened nor
     * looked up (react-router v5 does not decode params). An id cannot be typed wrong, never
     * needs encoding, and survives a rename. The name is still on the page, which is where it
     * is actually read.
     *
     * Domain is still the publisher's identity within a seat and is still what gets fetched -
     * it just isn't the address any more.
     */
    public trackedPublisher(id: string = ":id"): string {
        return `${this.appAdsLines()}/${id}`
    }
    public editTrackedPublisher(id: string = ":id"): string {
        return `${this.appAdsLines()}/${id}/edit`
    }
    public runLogs(): string {
        return "/runLogs";
    }
    public getRunLogCsv(runLogId:string = ":id"): string {
        return `${this.runLogs()}/${runLogId}/csv`;
    }
    public getBulkRunLogsCsv(): string {
        return `${this.runLogs()}/bulk/csv`;
    }
}

const urlService = new UrlsService();

export {urlService}
